import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { Observable } from 'rxjs';
import { DiscordMember } from '../../shared/models/DiscordMember';

@Injectable()
export class DiscordService {
  private discordBotApiUrl = APP_SETTINGS.DiscordBotApiUrl;
  private discordGetMemberByUserIdUrl = APP_SETTINGS.DiscordGetMemberByUserIdUrl;

  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }
 
  public GetMemberByUserId(userId: string): Observable<DiscordMember> {
    let urlWithId = this.discordGetMemberByUserIdUrl.replace('{userId}', userId);
    const url: string = this.discordBotApiUrl + urlWithId;
    
    return this.executeService.ExecuteWithApiToken('get', url)
      .pipe(
        map(discordMemberResponse => this.mapDiscordMember(discordMemberResponse)),
        catchError(this.errorHandler.handleError(DiscordService.name + '_' + this.discordGetMemberByUserIdUrl, null, true))
      );
  }

  private mapDiscordMember(discordMemberResponse: any): DiscordMember {
    if(discordMemberResponse) {
      return {
        UserId: discordMemberResponse.userId,
        MemberId: discordMemberResponse.memberId,
      };
    } else {
      return {
        UserId: '',
        MemberId: '',
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/discordService.service.ts